const matched = (x) => ({
  on: () => matched(x),
  otherwise: () => x,
});

/**
 * @template T
 * @param {T} x
 */
export const match = (x) => ({
  /**
   * @param {T|T[]} pred
   * @param {any} fn
   */
  on: (pred, fn) => {
    const getResult = () => (typeof fn === "function" ? fn(x) : fn);

    if (typeof pred === "function" && pred(x)) return matched(getResult());
    if (Array.isArray(pred) && pred.includes(x)) return matched(getResult());
    if (x === pred) return matched(getResult());

    return match(x);
  },
  /**
   * @param {any} fn
   */
  otherwise: (fn) => (typeof fn === "function" ? fn(x) : fn),
})